import React, { FC } from 'react';
import { Dialog, DialogContent, DialogProps, Paper } from '@mui/material';
import { EfacityActionLogo } from '../EfacityLoading/EfacityActionLogo';

export const MessageSmallModal: FC<{ message: string } & DialogProps> = ({ open, message = '' }) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperComponent={(props) => {
        return <Paper style={{ position: 'absolute', top: 0 }} {...props} />;
      }}
    >
      <DialogContent>
        <div>
          <EfacityActionLogo message={message} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
